<template>
  <div class="import_forms_modal__wrapper" @click.self="closeModal">
    <div class="import_forms_modal__container">
      <div class="modal__title d-flex justify-content-between align-items-center">
        <h4 class="mb-0 px-2 py-1">
          {{ $t("navigations.import from form library") }}
        </h4>
        <div class="cursor-pointer px-2 py-1">
          <span class="tooltip-wrapper pointer" style="float:right">
            <i class="fa fa-times" @click.prevent="closeModal"></i>
            <span class="custom-tooltip closetooltipposition">Close</span>
          </span>
        </div>
      </div>
      <div class="wrapper wrapper-content p-3">
        <div class="form-group row">
          <div class="d-flex justify-content-center">
            <div class="col-lg-10 pl-0 pr-1">
              <label class="mb-1">{{ $t("navigations.select form") }}</label>
              <Multiselect
                mode="multiple"
                :searchable="true"
                trackBy="formLibraryName"
                v-model="importTemplateId"
                :placeholder="$t('navigations.select form')"
                :tag-placeholder="$t('navigations.selected')"
                :selected-label="$t('navigations.selected')"
                valueProp="formLibraryId"
                label="templateName"
                :options="formlibrarylist"
                :hideSelected="false"
                :closeOnSelect="false"
                class="multiselect-template-theme mr-0"
                :maxHeight="300" 
              >
                <template v-slot:option="{ option }">
                  {{ option.formLibraryName }} ( {{ option.version }}) - {{ option.languageCode.toUpperCase() }}
                </template>
              </Multiselect>
              <span class="errorClass" v-if="importError">
                {{ $t("navigations.no forms selected") }}
              </span>
            </div>
            <div class="col-lg-2 px-0 d-flex align-items-end">
              <button
                class="save_btn w-100"
                style="padding:3px 4px"
                type="button"
                @click.prevent="ImportFun()"
              >
                <span v-if="isImporting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span v-else>{{ $t("navigations.import") }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import store from "../../store/index";
import Multiselect from "@vueform/multiselect";
import { useI18n } from "vue-i18n";

export default {
  name: "importForms",
  setup() {
    const { t, locale } = useI18n({ useScope: "global" });
    return { t, locale };
  },
  components: {
    Multiselect,
  },
  props: {
    studyVersion: {
      type: String,
      default: ""
    },
  },
  async mounted() {
    window.addEventListener("studyIdChanged", async (event) => {
      this.studyId = store.getters.getStudyIs;
      await this.getformLibrarydata();
    });
    this.studyId = store.getters.getStudyIs;
    await this.getformLibrarydata();
    
    // Prevent body scroll when modal is open
    document.body.style.overflow = 'hidden';
  },
  beforeUnmount() {
    // Restore body scroll when modal is closed
    document.body.style.overflow = '';
  },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      templatelist: [],
      studyId: "",
      importTemplateId: [],
      importvalue: {
        formLibraryIds: [],
        studyId: ""     
      },
      formlibrarylist: "",
      importError: false,
      isImporting: false,
    };
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
      this.$emit("importForms");
    },
    async getformLibrarydata() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseurl}/forms/formslibrary/listformlibrary?Status=Approved`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.formlibrarylist = (res.data.results || []).sort((a, b) =>
            a.formLibraryName.localeCompare(b.formLibraryName)
          );
        })
        .catch((err) => {
          console.log("error in get template details ", err);
        });
    },
    async ImportFun() {
      this.importError = false;
      this.importvalue.formLibraryIds = this.importTemplateId;
      
      if (!this.importvalue.formLibraryIds || this.importvalue.formLibraryIds.length < 1) {
        this.importError = true;
        return;
      }
      
      this.importvalue.studyId = store.getters.getStudyIs;
      const idtoken = store.getters.getIdToken;
      this.isImporting = true;
      
      await axios
        .post(
          `${this.baseurl}/forms/template/copyfromlibrary`,
          this.importvalue,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          alert(this.$t('navigations.form imported successfully'));
          this.closeModal();
          this.$emit("importForms");
        })
        .catch((err) => {
          alert(err.response.data.detail);
        })
        .finally(() => {
            this.isImporting = false;  
        });
        },
  },
};
</script>
  
<style scoped>
@import "../../assets/style.css";
@import "../../assets/formpage.css";
@import "../../assets/savepages.css";

.import_forms_modal__wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  z-index: 3000;
  height: 100vh;
  width: 100vw;
}

.import_forms_modal__container {
  position: relative;
  width: min(35%, 90%);
  max-width: 600px;
  border-radius: 4px;
  background: #fff;
  max-height: 90vh; /* Limit modal height */
  display: flex;
  flex-direction: column;
}

.modal__title {
  background-color: var(--pop-up-background);
  color: white;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  flex-shrink: 0;
}
.modal__title h4 {
  font-size:0.8rem !important;
  font-weight: 500;
  margin: 0;
}
.wrapper-content {
  overflow: visible; /* Ensure content is visible */
  flex-grow: 1;
  display: flex;
  align-items: center;
  padding: 1.5rem !important;
}

.form-group {
  width: 100%;
  margin: 0;
}

.multiselect-template-theme {
  --ms-option-bg-selected-pointed: rgb(210, 210, 210);
  --ms-option-bg-selected: rgb(210, 210, 210);
  --ms-option-color-selected: #000;
  --ms-option-color-selected-pointed: #000;
  --ms-radius: 0;
  --ms-line-height: 0.8;
  --ms-option-font-size: 0.8rem;
  --ms-font-size: 0.8rem;
  --ms-py: 0.4rem;
  --ms-max-height: 300px; /* Control dropdown height */
}

.tooltip-wrapper {
  position: relative;
  display: inline-block;
}

.custom-tooltip {
  visibility: hidden;
  width: 60px;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: -18%;
  left: -375%;
  margin-left: -30px;
  opacity: 0;
  transition: opacity 0.3s;
  font-size: 12px;
}

.closetooltipposition {
  bottom: -10px !important;
  margin-left: -25px !important;
}

.tooltip-wrapper:hover .custom-tooltip {
  visibility: visible;
  opacity: 1;
}

.errorClass {
  color: red;
  font-size: 0.8rem;
  display: block;
  margin-top: 5px;
}

/* Ensure dropdown has scroll */
:deep(.multiselect-dropdown) {
  overflow-y: auto !important;
}

/* Hide scrollbar on modal wrapper but show on dropdown */
.import_forms_modal__wrapper::-webkit-scrollbar,
.import_forms_modal__container::-webkit-scrollbar {
  display: none;
}
</style>